import React from 'react';
import { Flex, HStack, Text, FlexProps, useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared';
import InfoItem from './InfoItem';

interface NFTDetailQuantityProps extends FlexProps {
  forSaleAmount: number;
  onSaleAmount: number;
  totalAmount: number;
}

const NFTDetailQuantity = (props: NFTDetailQuantityProps) => {
  const { t } = useTranslation();
  const { forSaleAmount, onSaleAmount, totalAmount, ...remainingProps } = props;
  const bgColor = useColorModeValue(Colors.light.bg, Colors.dark.bg);
  const primaryColor = useColorModeValue(Colors.light.primary, Colors.dark.primary);

  const textStyle = { as: 'span' as 'span', color: primaryColor, fontWeight: 700, fontSize: '3xl' };
  return (
    <Flex
      flexDirection="column"
      alignItems="inherit"
      borderRadius={8}
      p={4}
      bg={bgColor}
      {...remainingProps}
    >
      <HStack pb={2}>
        <InfoItem title={t('Component:NFTDetailQuantity.OnSale')}>
          <Text {...textStyle}>{onSaleAmount}</Text>
        </InfoItem>
        <InfoItem title={t('Component:NFTDetailQuantity.ForSale')}>
          <Text {...textStyle}>{forSaleAmount}</Text>
        </InfoItem>
      </HStack>
      <Text>{t('Component:NFTDetailQuantity.Total', { totalQuantity: totalAmount })}</Text>
    </Flex>
  );
};

export default React.memo(NFTDetailQuantity);
